'use client';

import config from '@actr/config';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import React, { memo } from 'react';

import { RouteAirlines } from '@/services/models/avia/route-airlines';

import * as Styled from './style.css';

export type CityAirlinesBlockProps = {
  airlines: RouteAirlines;
  id?: string;
}

const CityAirlinesBlock: React.FC<CityAirlinesBlockProps> = ({ airlines, id = 'airlines' }) => {
  if (!airlines.list) {
    return null;
  }

  return (
    <ContentBlock id={id} tagProps={{ itemScope: true, itemType: 'https://schema.org/ItemList' }}>
      <Text tagName="h3" font="title.x2l" tagProps={{ itemProp: 'name' }}>
        {airlines.title}
      </Text>
      <div className={Styled.MainWrapper}>
        {airlines.list.map((item, index) => (
          <div itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem" key={index}>
            <meta itemProp="position" content={(index + 1).toString()} />
            <div itemProp="item" itemScope itemType="http://schema.org/Airline">
              <a
                className={Styled.AirlineWrapper}
                href={item.url ? `/${item.url}` : undefined}
                key={index}>
                <img
                  loading="lazy"
                  itemProp="logo"
                  className={Styled.AirlineLogo}
                  src={`${config.staticURL}/suppliers_redesign/square/${item.code}.png`}
                  alt={`${item.name}`}
                />
                <Text font="title.s" tagProps={{ itemProp: 'name' }}>
                  {item.name}
                </Text>
              </a>
            </div>
          </div>
        ))}
      </div>
    </ContentBlock>
  );
};

export default memo(CityAirlinesBlock);
